module.exports = __webpack_public_path__ + "static/media/logo_animalcrossing_cn.b6a647b4.svg";